import React from 'react';

import { IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useSnackbar } from 'notistack';

import { AppContext } from './app.context';
import { AppState } from './app-state.interface';
import { appStateReducer } from './app-state.reducer';
import { Alert } from '../../interfaces';

export function AppProvider({
  children,
  initialState
}: {
  children: React.ReactNode;
  initialState: AppState;
}): JSX.Element {
  const [appState, appStateDispatch] = React.useReducer(appStateReducer, initialState);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const addAlert = (alert: Alert): void => {
    enqueueSnackbar(alert.message, {
      variant: alert.variant,
      autoHideDuration: 6000,
      action: function closeAction(key): JSX.Element {
        return (
          <IconButton
            onClick={(): void => {
              closeSnackbar(key);
            }}
            title='close alert'
          >
            <CloseIcon />
          </IconButton>
        );
      }
    });
  };

  return (
    <AppContext.Provider value={{ appState, appStateDispatch, addAlert }}>
      {children}
    </AppContext.Provider>
  );
}
